<header class="app-header large-screen-header">
  <!-- Left Side: Search -->
  <div class="left-section">
    <li class="nav-item menu-bar d-block d-xl-none">
      <a class="nav-link sidebartoggler" (click)="toggleSidebar()">
        <i class="ti ti-menu-2"></i>
      </a>
    </li>
    <div class="current-date text-center">
      <i class="ti ti-calendar"></i> {{ currentDate | date:'fullDate' }} | {{ currentDate | date:'shortTime' }}
    </div>
    <!--  <div class="search-container">
      <i class="fa fa-search"></i>
      <input type="text" class="form-control" placeholder="Search by name">
    </div> -->
  </div>

  <!-- Right Side: Date + Controls -->
  <div class="right-section">
    <a *ngIf="constants.hasModulePermission('Scan_QR','LIST')" class="btn d-flex align-items-center gap-1 qr-button"
      (click)="openScanner = true">
      <i class="bi bi-qr-code-scan" title="Scan QR code"></i>
    </a>
    <a *ngIf="constants.hasModulePermission('Visit','ADD')"
      class="btn btn-primary d-flex align-items-center gap-1 add-visit-btn" routerLink="/create-visit">
      <img src="assets/icons/Add_Plus.png" alt="Add Visit" />
      <span>Add Visit</span>
    </a>
    <!-- Notification Icon -->
    <a *ngIf="constants.hasModulePermission('Notifications','LIST')" class="nav-link position-relative"
      (click)="toggleNotificationPanel();">
      <img src="assets/icons/mage_notification-bell.png" class="ti-bell" alt="Notifications" />
      <span *ngIf="unreadCount > 0" class="notification-count">{{ unreadCount }}</span>
    </a>
    <!-- Notification Panel -->
    <div *ngIf="showNotifications" class="notification-panel">
      <div class="notification-header sticky-top bg-white">
        <h4 class="fw-bold mb-0">Notifications</h4>
        <button class="btn-close mb-2" (click)="showNotifications = false"></button>
      </div>

      <div class="notification-body">
        <div *ngIf="notifications.length > 0; else noNotifications">
          <div *ngFor="let notification of notifications" class="notification-item cursor-pointer"
            (click)="onNotificationClick(notification)">
            <strong class="p-1">🔔 {{ notification.title }}</strong>
            <p class="p-2 mb-0">{{ notification.message }}</p>
          </div>
        </div>
        <ng-template #noNotifications>
          <p class="text-muted text-center mt-3">You have no notifications.</p>
        </ng-template>
      </div>

      <div class="notification-footer sticky-bottom bg-white d-flex justify-content-between">
        <a class="fw-semibold text-link" *ngIf="notifications.length > 0" (click)="markAllAsRead()">Mark all as read</a>
        <a class="fw-semibold text-link text-end ms-auto" (click)="viewAllNotifications()">View All</a>
      </div>
    </div>
    <!-- Role Section -->
    <!-- Role Section (Periscope: Only Admin, no dropdown needed) -->
    <!-- <div class="d-flex align-items-center user-role">
      <img src="assets/icons/mo-head-user-icon.png" class="user-icon me-2" />
      <span class="fw-bold text-dark"> {{ userRole }} </span>
    </div> -->

    <div class="d-flex justify-content-center rounded rounded-pill border border-2 bg-white p-2">

      <img class="" src="assets/icons/mo-head-user-icon.png" class="" />
      <span class="fw-bold text-dark justify-content-center mt-2 me-1"> {{ userRole }} </span>
    </div>






  </div>


</header>

<!-- Mobile View Header -->
<header class="app-header mobile-header d-block d-xl-none" style="background-image: url('assets/images/headerbg.svg');">
  <div class="mobile-top">
    <!-- Left: Logo & Date Centered -->
    <div class="logo-date-section">
      <img src="assets/images/whitelogo.svg" alt="Logo" class="logo-image" />
      <p class="date-text">{{userRole}}{{ currentDate | date: 'EEE d MMMM' }}</p>
    </div>

    <!-- Right: Notification & Profile -->
    <div class="icon-group">
      <!-- Notification Icon -->
      <a *ngIf="constants.hasModulePermission('Notifications','LIST')" class="nav-link position-relative"
        (click)="toggleNotificationPanel()">
        <img src="assets/icons/mage_notification-bell.png" class="ti-bell" alt="Notifications" />
        <span *ngIf="unreadCount > 0" class="notification-count">{{ unreadCount }}</span>
      </a>
      <!-- Notification Panel -->
      <div *ngIf="showNotifications" class="notification-panel">
        <div class="notification-header sticky-top bg-white">
          <h4 class="fw-bold mb-0">Notifications</h4>
          <button class="btn-close mb-2" (click)="showNotifications = false"></button>
        </div>

        <div class="notification-body">
          <div *ngIf="notifications.length > 0; else noNotifications">
            <div *ngFor="let notification of notifications" class="notification-item cursor-pointer"
              (click)="onNotificationClick(notification)">
              <strong class="p-1">🔔 {{ notification.title }}</strong>
              <p class="p-2 mb-0">{{ notification.message }}</p>
            </div>
          </div>
          <ng-template #noNotifications>
            <p class="text-muted text-center mt-3">You have no notifications.</p>
          </ng-template>
        </div>

        <div class="notification-footer sticky-bottom bg-white d-flex justify-content-between">
          <a class="fw-semibold text-link" *ngIf="notifications.length > 0" (click)="markAllAsRead()">Mark all as
            read</a>
          <a class="fw-semibold text-link text-end ms-auto" (click)="viewAllNotifications()">View All</a>
        </div>
      </div>
      <!-- <div class="profile-icon">
        <img [src]="user.photo || 'assets/images/profile/profile.png'" alt="Profile" />

      </div> -->
      <!-- <div class="profile-icon position-relative">
            <img [src]="user.photo || 'assets/images/profile/profile.svg'"
                alt="Profile" (click)="openRoleDropdown()" style="cursor: pointer;" />

            <select #roleDropdown class="form-select form-select-sm text-muted position-absolute"
                    [(ngModel)]="selectedRole"
                    (change)="onRoleChange($event)"
                    style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
              <option *ngFor="let r of roles" [ngValue]="r">{{ r.name }}</option>
            </select>
        </div> -->

    </div>
  </div>
</header>

<!-- Tablet/Ipad View Header -->
<header class="app-header medium-screen-header">
  <div class="tab-top">
    <a class="nav-link sidebartoggler" (click)="toggleSidebar()">
      <img src="assets/icons/mi_menu.png" alt="Menu" class="menu-icon" />
    </a>
    <div class="title-section">
      <img src="assets\images\PeriscopeLogo.png" alt="Logo" class="tab-logo" />
    </div>
    <div class="header-icons">
      <div class="current-date">
        <i class="ti ti-calendar"></i> {{ currentDate | date:'fullDate' }} | {{ currentDate | date:'shortTime' }}
      </div>
      <a *ngIf="constants.hasModulePermission('Scan_QR','LIST')" class="btn d-flex align-items-center gap-1 qr-button"
        (click)="openScanner = true">
        <i class="bi bi-qr-code-scan" title="Scan QR code"></i>
      </a>
      <a *ngIf="constants.hasModulePermission('Visit','ADD')"
        class="btn btn-primary d-flex align-items-center gap-1 add-visit-btn">
        <img src="assets/icons/Add_Plus.png" alt="Add Visit" routerLink="/create-visit" />
        <span>Add Visit</span>
      </a>
      <!-- Notification Icon -->
      <a *ngIf="constants.hasModulePermission('Notifications','LIST')" class="nav-link position-relative"
        (click)="toggleNotificationPanel()">
        <img src="assets/icons/mage_notification-bell.png" class="ti-bell" alt="Notifications" />
        <span *ngIf="unreadCount > 0" class="notification-count">{{ unreadCount }}</span>
      </a>
      <!-- Notification Panel -->
      <div *ngIf="showNotifications" class="notification-panel">
        <div class="notification-header sticky-top bg-white">
          <h4 class="fw-bold mb-0">Notifications</h4>
          <button class="btn-close mb-2" (click)="showNotifications = false"></button>
        </div>

        <div class="notification-body">
          <div *ngIf="notifications.length > 0; else noNotifications">
            <div *ngFor="let notification of notifications" class="notification-item cursor-pointer"
              (click)="onNotificationClick(notification)">
              <strong class="p-1">🔔 {{ notification.title }}</strong>
              <p class="p-2 mb-0">{{ notification.message }}</p>
            </div>
          </div>
          <ng-template #noNotifications>
            <p class="text-muted text-center mt-3">You have no notifications.</p>
          </ng-template>
        </div>

        <div class="notification-footer sticky-bottom bg-white d-flex justify-content-between">
          <a class="fw-semibold text-link" *ngIf="notifications.length > 0" (click)="markAllAsRead()">Mark all as
            read</a>
          <a class="fw-semibold text-link text-end ms-auto" (click)="viewAllNotifications()">View All</a>
        </div>
      </div>
      <!-- <div class="icon-circle position-relative">
            <img src="assets/icons/mo-head-user-icon.png"
                alt="Profile" (click)="openRoleDropdown()" style="cursor: pointer;" />

            <select #roleDropdown class="form-select form-select-sm text-muted position-absolute"
                    [(ngModel)]="selectedRole"
                    (change)="onRoleChange($event)"
                    style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
              <option *ngFor="let r of roles" [ngValue]="r">{{ r.name }}</option>
            </select>
        </div> -->

    </div>
  </div>
  <div class="search-container">
    <i class="fa fa-search"></i>
    <input type="text" class="form-control" placeholder="Search by name">
  </div>
</header>

<!-- <app-qr-scanner *ngIf="openScanner" (scanned)="handleScan($event)" /> -->